import React, {Component} from 'react';
import {Button, Divider, Form, Header, Message, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {CustomGrid, CustomEmailInput} from "./custom-common";
import {getLocalization} from "../utils/localization";
import {isEmailValid, PASSWORD_RESET_REQUEST_SENT, resolveErrorMessage} from "../utils/common";
import {connect} from "react-redux";
import {requestResetPassword} from "../services/services";
import {RequestResetPasswordRequest} from "../services/types";


const mapStateToProps = (state, ownProps) => {
    const {initialData} = state;
    return {
        ...ownProps,
        token: initialData.token,
    }
};

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,
            email: null,
        };
    }

    handleChange = (e, {name, value}) => this.setState({[name]: value, error: ''})

    handleSubmit = async () => {
        const {token} = this.props;
        const {email} = this.state
        try {
            this.setState({loading: true, error: null});
            const payload = new RequestResetPasswordRequest( {
                email,
                token,
            });
            await requestResetPassword(payload)
            this.props.history.replace({pathname: `${PASSWORD_RESET_REQUEST_SENT}`, state: { email: email }});
        } catch (e) {
            console.warn(e)
            const error = resolveErrorMessage(e, "Unable to send reset password request")
            this.setState({loading: false, error: error})
        }
    }

    render() {
        const {email, loading, error} = this.state;
        const isExpiredLink = this.props.location.state && this.props.location.state.resetLink;
        const localization = getLocalization(this.props.lang);
        const strings = localization.expiredToken;

        return (
            <React.Fragment>
                <CustomGrid container stackable columns={1} centered style={{marginTop: 0}} fitted={'horizontally'}>
                    <CustomGrid.Column>
                        <CustomGrid centered>
                            <CustomGrid.Column style={{marginTop: '3em'}} width={5}>
                                <Divider hidden/>
                                <Header as={"h2"} textAlign={"center"}>
                                    {isExpiredLink ? `${strings.title}` : 'Forgot Password'}
                                </Header>
                                <Segment padded>
                                    <p className={"small"}>
                                        {isExpiredLink ? `${strings.descr}` : 'Enter your email address and we’ll send you a link to reset your password—'}
                                    </p>
                                    <Form>
                                        <CustomEmailInput
                                            name='email'
                                            value={!!email ? email : ''}
                                            onChange={(e, {value}) => {
                                                this.setState({email: value});
                                            }}
                                        />
                                        <Button primary loading={loading} onClick={this.handleSubmit} disabled={!email || !isEmailValid(email)}>
                                            Send link
                                        </Button>
                                        {error && <Divider hidden/>}
                                        {error && <Message negative size="mini">{error}</Message>}
                                    </Form>
                                </Segment>
                            </CustomGrid.Column>
                        </CustomGrid>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ForgotPassword));